module.exports = __webpack_public_path__ + "img/user.1a000588.svg";